<template>
    <div class="col-12 mt-4">
        <h4>
            <i class="fa fa-smile-o fa-lg mr-3" aria-hidden="true"></i>
            {{ $lang('Ocena obsługi zgłoszenia') }}
        </h4>
        <hr class="colorgraph d-print-none">
        <div class="d-flex flex-column">
            <vue-feedback-reaction v-model="feedback" :labels="labels"/>
            <div class="form-group" v-if="feedback > 0 && feedback < 3">
                <label for="description">{{ $lang('Uzasadnienie') }}:</label>
                <textarea class="form-control" id="feedback_note" name="feedback_note" v-model="note"
                          rows="3"></textarea>
            </div>
        </div>
    </div>
</template>

<script>
import {VueFeedbackReaction} from 'vue-feedback-reaction';

export default {
    components: {VueFeedbackReaction},
    props: {
        evaluation: {type: Object, default: null}
    },
    data() {
        return {
            feedback: 0,
            note: '',
            labels: [
                this.$lang('Bardzo źle'),
                this.$lang('Źle'),
                this.$lang('Przeciętnie'),
                this.$lang('Dobrze'),
                this.$lang('Bardzo dobrze'),
            ]
        }
    }
}
</script>
